import type { ITableProps } from "@similarweb/pro-logic-components/dist/table/utils/types";

import { translate } from "app/filters/i18nFilter";

export const DEFAULT_NO_DATA_VIEW: ITableProps["noData"] = {
    get title() {
        return translate("si.common.table.no-data.no-results");
    },
    get subtitle() {
        return translate("global.nodata.notavilable");
    },
};
